import {createContext} from "react";

interface MSpinner {
    showSpinner: (key?: string) => void
    hideSpinner: (key?: string) => void
}

interface MToast {
    showInfo: (info: string, complete?: () => void) => void,
    showSuccess: (title: string, complete?: () => void) => void,
    showError: (error: Error | string, complete?: () => void) => void,
}

interface MAlert {
    showAlert: (title: string, message?: string, onResolve?: {title: string, onClick?: () => void}, onReject?: {title: string, onClick?: () => void}) => void
}

export type MPrompt = MSpinner & MToast & MAlert

const defaultValue = {
    showSpinner: () => {
        //
    },
    hideSpinner: () => {
        //
    },
    showInfo: () => {
        //
    },
    showSuccess: () => {
        //
    },
    showError: () => {
        //
    },
    showAlert: () => {
        //
    },
} as MPrompt

export const PromptContext = createContext<MPrompt>(defaultValue)
